// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cy","cardHeaderIcon__content":"c-e_cz"};